export default function floatToCurrency(value: number | string): string {
  if (typeof value === 'string' && isNaN(Number(value))) {
    return value;
  }

  const options = {
    style: 'currency',
    currency: 'BRL',
  } as const;

  return value.toLocaleString('pt-BR', options);
}
